import {
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { FunctionComponent, useMemo } from "react";

import { DVInlineProps } from "./types";
import IcIcon from "../../../IcIcon";
import { gql } from "@shared/utils";
import { useGqlField } from "../../../../hooks";

const EDIT_OPERATOR = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, operator: $value }) {
      _id
      operator
    }
  }
`;

const OPERATORS: Array<{
  icon?: string;
  text?: string;
  value: string;
}> = [
  {
    value: "+",
    icon: "ant-design:plus-outlined",
  },
  {
    value: "-",
    icon: "ant-design:minus-outlined",
  },
  {
    value: "*",
    icon: "humbleicons:times",
  },
  {
    value: "/",
    icon: "ic:round-divide",
  },
  {
    value: "(",
    text: "(",
  },
  {
    value: ")",
    text: ")",
  },
  {
    value: "round(",
    text: "Round("
  },
  {
    value: "floor(",
    text: "Floor("
  },
  {
    value: "ceil(",
    text: "Ceil("
  },
  {
    value: ",",
    text: ","
  }
];

export const DVInlineOperator: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
}) => {
  const [operator, setOperator] = useGqlField(
    dynamicVariable.operator || 0,
    dynamicVariable._id,
    EDIT_OPERATOR
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const currentIcon = useMemo(() => {
    const op = OPERATORS.find(({ value }) => value === operator);
    if (!op || !(op.icon || op.text)) return undefined;
    return op;
  }, [operator]);
  return (
    <div>
      {currentIcon ? (
      <IconButton
        onClick={handleClick}
        sx={
          currentIcon.text
            ? { width: ( currentIcon.text.length * 10 ) + 28, height: 38, p: 0, lineHeight: 0 }
            : undefined
        }
      >
        {currentIcon.icon ? <IcIcon icon={currentIcon.icon} /> : null}
        {currentIcon.text ? (
          <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
            {currentIcon.text}
          </Typography>
        ) : null}
      </IconButton>
      ) : null}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {OPERATORS.map((menu) => {
          const key = menu.value;
          return (
            <MenuItem
              key={key}
              onClick={() => {
                setOperator(menu.value);
                handleClose();
              }}
            >
              {menu.icon ? <IcIcon icon={menu.icon} /> : null}
              {menu.text ? <Typography>{menu.text}</Typography> : null}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
